import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  SP_CLIENT_ID_DEV,
  SP_CLIENT_ID_STAGE,
  SP_CLIENT_ID_LIVE,
} from "../../../utils/constants";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, getClientIdFromUrl } from "../../../utils/commonLogics";
import { useNavigate } from "react-router-dom";

export const getEnvFromUrl = (hostname) => {
  if (hostname.includes("app-dev.panel.qualsights.com")) {
    return "development";
  } else if (hostname.includes("app-stage.panel.qualsights.com")) {
    return "staging";
  } else if (
    hostname.includes("app.panel.qualsights.com") ||
    hostname.includes("platform.usesights.com") ||
    hostname.includes("usesights.qualsights.com")
  ) {
    return "clients";
  } else {
    return "development";
  }
};

const ViewResults = ({ isCategoryViewResults = false }) => {
  const { panel_projects, token, user } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const { categoryLength, tabVal } = state || {};
  const { studyId } = useSelector((state) => state.study);
  const { sessionId } = useSelector((state) => state.session);
  const { sessionCode } = useSelector((state) => state.sessionCode);
  const [mode, setMode] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const tid = searchParams.get("tid");
  const study_id = studyId ? studyId : decrypt(searchParams.get("studyId"));
  const location = useLocation();
  const hostname = window.location.hostname;
  const match = location.pathname.match(/fromClient-(\d+)/);
  const clientId = match ? match[1] : null;
  const lastSegment = location.pathname.split("/").pop();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname.includes("create")) {
      setMode("add");
    } else if (window.location.pathname.includes("edit")) {
      setMode("edit");
    } else {
      setMode("clone");
    }
  }, []);

  const handleBack = () => {
    if (isCategoryViewResults) {
      navigate(
        user.type === "superadmin"
          ? `/admin-panel/other-activities/${lastSegment}`
          : `/dashboard/other-activities`,
      );
      return;
    }
    navigate(
      user.type === "superadmin"
        ? `/admin-panel/survey/${lastSegment}`
        : `/dashboard/survey`,
    );
  };

  const iframeSrc = isCategoryViewResults
    ? `https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/mr/ai-responses/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/tab/summaryvisual/showResponseTab/1?v=1&xmot_results=1&tab_val=${tabVal}&env=${window.location.origin}&tstring=${token}`
    : `https://${getEnvFromUrl(hostname)}.qualsights.com/admin-console2/mr/ai-responses/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/tab/summaryvisual/showResponseTab/1?v=1&xmot_results=1&env=${window.location.origin}&tstring=${token}&xmot_session_id=${sessionId}&xmot_session_code=${sessionCode}`;

  return (
    <div
      className="container-fluid page-wrapper mt-2"
      style={{ position: "relative" }}
    >
      <div className="row">
        <div className="col-12">
          <div
            className="card shadow-card"
            style={{
              minHeight:
                categoryLength === 1
                  ? "calc(100vh - 140px)"
                  : "calc(100vh - 180px)",
              overflow: "hidden",
            }}
          >
            {categoryLength === 1 ? (
              ""
            ) : (
              <div className="d-flex justify-content-between align-items-center p-3">
                <h6
                  className="m-0 title fs-13"
                  onClick={handleBack}
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="pi pi-angle-left"
                    style={{ verticalAlign: "bottom" }}
                  ></span>{" "}
                  Back
                </h6>
              </div>
            )}
            <div
              style={{
                width: "100%",
                height:
                  categoryLength === 1
                    ? "calc(100vh - 140px)"
                    : "calc(100vh - 180px)",
                border: "1px solid #ccc",
                boxSizing: "border-box",
                position: "relative",
                overflow: "auto",
              }}
            >
              {/* Loader overlay */}
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fff",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ color: "black" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              <iframe
                src={iframeSrc}
                // src={`https://development.qualsights.com/admin-console2/ai/ai-reports/id/${getClientIdFromUrl(hostname)}/pid/${study_id}/showResponseTab/1?xmot_results=1&env=${window.location.origin}&tstring=${token}&xmot_session_id=${sessionId}`}
                title="Third Party Content"
                width="100%"
                height="100%"
                style={{ border: "none", display: "block" }}
                allowFullScreen
                onLoad={() => setLoading(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewResults;
